var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "103px",
    viewBox: "0 0 100 103",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "plate") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "92.7838577%",
    y1: "83.7378561%",
    x2: "20.820254%",
    y2: "4.632213%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "93.5176681%",
    y1: "83.7378561%",
    x2: "20.3197755%",
    y2: "4.632213%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "20.3197755%",
    y1: "4.632213%",
    x2: "93.5176681%",
    y2: "83.7378561%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-4",
    cx: 51,
    cy: 54,
    rx: 44,
    ry: 44.5
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.5%",
    y: "-5.5%",
    width: "111.1%",
    height: "110.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.97247061,6.02828799 C0.908875768,6.74215469 0.554344156,8.16988807 0.731609962,9.77608814 C0.908875768,11.3822882 5.78267601,30.3435029 29.5253418,31.9730826 C53.2680075,33.6026623 59.0520602,19.4132885 59.0520602,16.9147551 C59.0520602,14.4162216 59.4065918,11.7392215 60.6474525,9.77608814 C61.8883131,7.81295473 64.1927686,7.09908803 65.0790976,5.3144213 C65.9654267,3.52975456 65.6390408,0.928322906 64.3700344,0.674287786 C63.101028,0.420252666 60.8247183,1.03122113 59.9383893,3.52975456 C59.0520602,6.02828799 56.9248706,9.77608814 55.8612757,10.4899548 C54.7976809,11.2038215 52.1386938,11.2038215 48.238846,13.702355 C28.5379159,26.3242407 7.64497641,8.52682142 5.87231834,6.92062136 C4.09966028,5.3144213 3.03606544,5.3144213 1.97247061,6.02828799 Z",
    id: "path-6"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-13.9%",
    y: "-22.2%",
    width: "133.9%",
    height: "169.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4,
    in: "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "path-9",
    cx: 45,
    cy: 57.5,
    r: 2
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-100.0%",
    y: "-100.0%",
    width: "300.0%",
    height: "350.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-10"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "path-11",
    cx: 53,
    cy: 60.5,
    r: 2
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-100.0%",
    y: "-100.0%",
    width: "300.0%",
    height: "350.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-12"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M26.3148642,13.3561156 C26.3148642,20.7164455 20.4582248,26.6830451 13.2335407,26.6830451 C6.00885648,26.6830451 0.152217117,20.7164455 0.152217117,13.3561156 C0.152217117,5.9957858 6.00885648,0.0291862303 13.2335407,0.0291862303 C20.4582248,0.0291862303 26.3148642,5.9957858 26.3148642,13.3561156",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-19.1%",
    y: "-18.8%",
    width: "153.5%",
    height: "152.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-14"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-15",
    cx: 12.661685,
    cy: 12.661685,
    r: 12.661685
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-19.7%",
    y: "-19.7%",
    width: "155.3%",
    height: "155.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-16"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HH---Complete-the-assessments-and-reveal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Employer-Dashboard-LG-03.7.0-Copy-3",
    transform: "translate(-984.000000, -1465.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plate",
    transform: "translate(984.000000, 1465.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    cx: 50,
    cy: 51.5,
    rx: 50,
    ry: 51
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    opacity: 0.200000003
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-2)",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "url(#linearGradient-3)",
    strokeWidth: 1.74375,
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(50.071512, 69.072825) rotate(5.000000) translate(-50.071512, -69.072825) translate(17.071512, 52.572825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-48",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#62EBB9",
    fillRule: "evenodd",
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.701382363,6.99411587 C1.21221192,7.16742373 2.59480685,7.36467025 3.77819715,5.69717554 C4.56712402,4.5855124 3.94167996,4.37331957 1.90186497,5.06059705 C0.816652214,6.25295534 0.416491344,6.89746161 0.701382363,6.99411587 Z",
    fill: "#575756",
    mask: "url(#mask-7)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.6333602,2.35558127 C60.4314132,3.53293925 58.6456004,7.43790516 59.7523327,7.60429108 C60.859065,7.770677 61.2132598,5.4247744 61.9437234,5.96965357 C62.674187,6.51453274 64.3884547,5.54060009 64.6271151,3.69408437 C64.8657756,1.84756865 62.8353072,1.1782233 61.6333602,2.35558127 Z",
    id: "Path-47",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91880842,8.66638839 C21.5108015,25.8299719 37.9060603,27.6430264 53.1045849,14.1055522",
    id: "Path-49",
    stroke: "#FFFFFF",
    strokeWidth: 0.962068966,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-10)",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#62EBB9",
    fillRule: "evenodd",
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-12)",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#62EBB9",
    fillRule: "evenodd",
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-69",
    transform: "translate(34.724487, 39.638125) rotate(23.000000) translate(-34.724487, -39.638125) translate(21.224487, 26.138125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-14)",
    xlinkHref: "#path-13"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F8F8F8",
    fillRule: "evenodd",
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.1753465,13.3561156 C23.1753465,18.9499663 18.7243006,23.484582 13.2335407,23.484582 C7.74278068,23.484582 3.29173477,18.9499663 3.29173477,13.3561156 C3.29173477,7.76226496 7.74278068,3.22764929 13.2335407,3.22764929 C18.7243006,3.22764929 23.1753465,7.76226496 23.1753465,13.3561156",
    id: "Fill-1",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4502452,16.973644 L14.2617327,13.4365437 C13.9480425,13.2572965 13.691387,12.8107111 13.691387,12.4442205 L13.691387,5.17238146 C13.691387,4.8058909 13.9556297,4.63810486 14.2784768,4.79962725 C14.2784768,4.79962725 21.7364009,6.15950713 21.9326208,13.356049 C21.9712107,14.771902 21.2463746,16.6743212 21.2463746,16.6743212 C21.1222328,17.0182892 20.7639354,17.1530245 20.4502452,16.973644 M20.0181691,18.6762925 C20.0181691,18.6762925 17.8120039,22.1518224 13.2335407,22.2184571 C9.30901278,22.2756296 6.44538024,18.6716281 6.44538024,18.6716281 C6.18179157,18.4224145 6.22168961,18.0700505 6.53420243,17.8885377 L12.6018435,14.3651641 C12.9144872,14.1835181 13.4268826,14.1819188 13.7405728,14.3610328 L19.9275155,17.8974667 C20.2412057,18.0767139 20.2821502,18.4272122 20.0181691,18.6762925 M5.21848291,16.6691237 C5.21848291,16.6691237 4.52111755,14.7703028 4.5344605,13.356049 C4.59986712,6.42604571 12.0605384,4.81561956 12.0605384,4.81561956 C12.3819465,4.65089872 12.6448811,4.81601937 12.6448811,5.18250993 L12.6448811,12.4466193 C12.6448811,12.8131099 12.3891412,13.2615611 12.0766284,13.4430739 L6.01199599,16.964715 C5.69948317,17.1460945 5.34236304,17.0130917 5.21848291,16.6691237 M13.2335407,2.09479365 C7.13855958,2.09479365 2.17982226,7.14663279 2.17982226,13.356049 C2.17982226,19.5655985 7.13855958,24.6173044 13.2335407,24.6173044 C19.3286525,24.6173044 24.287259,19.5655985 24.287259,13.356049 C24.287259,7.14663279 19.3286525,2.09479365 13.2335407,2.09479365",
    id: "Combined-Shape",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8912357,8.91591594 L18.7328244,12.199005 C19.0896829,12.8353659 18.8071263,13.2258449 18.1047901,13.0667214 L17.41632,12.9107963 C16.7139838,12.7515395 15.6278415,12.9177263 15.0022926,13.2800855 L14.6933117,13.4590662 C14.3866673,13.636732 14.0653686,13.7233791 13.7923543,13.7204842 C13.9149972,13.9550471 13.9880891,14.2651142 13.9859784,14.6030231 L13.9831005,15.0497418 C13.9783912,15.7827229 14.4018337,16.7949032 14.9239093,17.2993275 L15.5380774,17.8923759 C16.060153,18.3966669 15.8988603,18.8064699 15.1793875,18.8032901 L11.4678236,18.7866128 C10.7483508,18.7832811 10.5576251,18.338828 11.0441195,17.7988208 L11.5209338,17.2693419 C12.0072974,16.7292015 12.4091556,15.6877019 12.4138649,14.9547208 L12.4162196,14.5924949 C12.4185284,14.2331305 12.5055156,13.9064091 12.644468,13.6670322 C12.3835672,13.6579294 12.0835257,13.5674031 11.7974599,13.3966562 L11.4190172,13.1706314 C10.7983084,12.8001428 9.7261631,12.6675399 9.03638491,12.8761063 L8.22521204,13.1214551 C7.53543385,13.3300215 7.26765916,12.9827217 7.63014263,12.3495593 L9.49998702,9.08312892 C9.86247049,8.44983323 10.335622,8.50407384 10.5515946,9.20320455 L10.7631196,9.88860853 C10.9792231,10.5877392 11.6636379,11.463052 12.2843467,11.8336739 L12.5911038,12.0167859 C12.8955467,12.1985671 13.1299073,12.4388261 13.2639333,12.6812211 C13.4017434,12.4555632 13.6288695,12.2359298 13.9173276,12.0688009 L14.2985174,11.8479737 C14.9240663,11.4857477 15.5728999,10.6061704 15.7404717,9.89317967 L15.9376072,9.05478254 C16.105179,8.34205835 16.5342464,8.27955506 16.8912357,8.91591594 Z",
    id: "Combined-Shape",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0036459,19.9691646 C11.1975111,20.2798153 11.1815519,20.6436405 10.9680647,20.7818407 C10.7547083,20.920041 10.4246665,20.7802415 10.2308013,20.469724 C10.0370669,20.1590733 10.0530261,19.7953814 10.2665133,19.6571812 C10.4798697,19.5188476 10.8099115,19.6586471 11.0036459,19.9691646 Z M12.3155719,19.2995663 C12.5634629,19.3502087 12.7069651,19.6837817 12.6359335,20.0445417 C12.5650327,20.4054349 12.3065457,20.6569141 12.0585238,20.6062718 C11.810502,20.5556294 11.6671306,20.2220564 11.7381622,19.8612964 C11.809063,19.5004032 12.06755,19.248924 12.3155719,19.2995663 Z M15.800842,19.6446938 C16.0395761,19.9208278 16.0794742,20.2827872 15.8896641,20.4529721 C15.699985,20.623157 15.3526758,20.5374648 15.1138109,20.2613308 C14.8750767,19.9850636 14.8351787,19.6231042 15.0251195,19.4529193 C15.2147987,19.2827344 15.5621078,19.3684266 15.800842,19.6446938 Z M14.1728843,19.4113659 C14.3628251,19.4501473 14.4728391,19.7057578 14.4184208,19.9824249 C14.3640025,20.2589587 14.1658204,20.4516661 13.9758796,20.4128847 C13.7859388,20.3741033 13.6759248,20.1184928 13.7303432,19.841959 C13.7847615,19.5654252 13.9829435,19.3725846 14.1728843,19.4113659 Z M17.5086088,18.8773825 C17.8255692,19.0542309 17.9838532,19.3807407 17.8624586,19.6066321 C17.7409331,19.8325236 17.3856443,19.8725044 17.0689455,19.6957893 C16.751985,19.5189409 16.593701,19.1925644 16.7150957,18.9665397 C16.8364903,18.7406482 17.1917791,18.7006675 17.5086088,18.8773825 Z M8.31339324,18.3937616 C8.41019504,18.5807384 8.28461433,18.8420795 8.03292967,18.9773478 C7.78111419,19.1128827 7.49842679,19.0710361 7.40162499,18.8840593 C7.30469239,18.6972158 7.43027309,18.4358747 7.68208857,18.3004731 C7.93377323,18.1649382 8.21646064,18.2067848 8.31339324,18.3937616 Z M9.9109368,17.1590749 C10.1619674,17.1901266 10.330324,17.5114389 10.286894,17.87673 C10.243464,18.2420212 10.0048607,18.5130909 9.7538301,18.4821724 C9.5027995,18.451254 9.33444287,18.1298084 9.37787286,17.7645173 C9.42130286,17.3992262 9.6599062,17.1281564 9.9109368,17.1590749 Z M17.3395065,17.3276072 C17.4363083,17.5145841 17.3107276,17.7759251 17.0589121,17.9111935 C16.8070966,18.0467284 16.52454,18.0048818 16.4277382,17.817905 C16.3309364,17.6310614 16.4565171,17.3697203 16.7082018,17.2343187 C16.9598865,17.0987839 17.2425739,17.1406304 17.3395065,17.3276072 Z M15.9467249,16.4481232 C15.9902857,16.7346522 15.8593416,16.9933279 15.6543573,17.025579 C15.4492421,17.0579635 15.2477898,16.8517959 15.204229,16.5651336 C15.1606682,16.2786046 15.2916122,16.0199289 15.4965965,15.9876778 C15.7015809,15.9552933 15.9031641,16.1614609 15.9467249,16.4481232 Z M11.2973609,15.8984806 C11.551531,16.0296176 11.6814285,16.2885599 11.5877663,16.4772692 C11.4939732,16.6658452 11.2122015,16.7126228 10.9581622,16.581619 C10.7041229,16.4506153 10.5742253,16.1915398 10.6678876,16.0029638 C10.7615499,15.8142544 11.0434524,15.7676102 11.2973609,15.8984806 Z M7.05490451,14.4698605 C7.27597888,14.7607873 7.29324623,15.1244792 7.0933636,15.2822701 C6.89348098,15.4400609 6.55205844,15.3319795 6.33085326,15.0409194 C6.10964807,14.7501258 6.09251154,14.3863006 6.29239416,14.228643 C6.49227679,14.0708522 6.83369933,14.1789336 7.05490451,14.4698605 Z M19.5706178,14.0639755 C19.8996131,14.2157692 20.0819667,14.5289521 19.9775778,14.7636393 C19.8733196,14.9984598 19.5220861,15.0656275 19.19296,14.9138338 C18.8638339,14.7620401 18.681611,14.4488572 18.786,14.21417 C18.8901273,13.9793495 19.2414917,13.9121818 19.5706178,14.0639755 Z M9.22908589,13.7293363 C9.32588768,13.9163131 9.20030698,14.1776542 8.94862231,14.3129225 C8.69680684,14.4484574 8.41411943,14.4066109 8.31731764,14.219634 C8.22038503,14.0327905 8.34596574,13.7714494 8.59778122,13.6360478 C8.84946588,13.5005129 9.13215328,13.5423595 9.22908589,13.7293363 Z M16.8720061,13.3541033 C17.0119763,13.5104282 16.9546801,13.7954912 16.7443324,13.990864 C16.5338539,14.1862367 16.2498584,14.2179548 16.1101499,14.0617632 C15.9704413,13.9054383 16.0276067,13.6203753 16.2380852,13.4251358 C16.4484329,13.229763 16.7322976,13.1980449 16.8720061,13.3541033 Z M6.49909216,13.0994523 C6.5815045,13.2933591 6.43669424,13.5440387 6.17546021,13.6593166 C5.91422618,13.7747278 5.63559399,13.7108918 5.55305084,13.5168517 C5.4706385,13.3229449 5.61557957,13.0722654 5.8768136,12.9569874 C6.13804763,12.8417095 6.41667982,12.9054122 6.49909216,13.0994523 Z M20.6826742,12.5059109 C20.8828184,12.7122117 20.9255944,12.9998069 20.778037,13.1484021 C20.6304797,13.2971307 20.348708,13.2504864 20.1484329,13.0443188 C19.9481579,12.8381512 19.9055127,12.5504228 20.0530701,12.4016943 C20.2004966,12.253099 20.4823991,12.2997433 20.6826742,12.5059109 Z M6.6918193,11.3339007 C7.10636644,11.4341192 7.38643758,11.7548984 7.31762981,12.050623 C7.24882205,12.3462143 6.85703641,12.5045382 6.44248927,12.4043197 C6.02807294,12.3041012 5.74787099,11.9831887 5.81667875,11.6875974 C5.88561733,11.3921394 6.27740297,11.2336822 6.6918193,11.3339007 Z M19.9395111,11.3538245 C19.9531157,11.5647898 19.7244541,11.7518998 19.4288162,11.7720235 C19.1329167,11.7920139 18.8818861,11.637155 18.8682815,11.4261897 C18.8544153,11.2152244 19.0832077,11.027981 19.3789764,11.0079906 C19.6748759,10.9880002 19.9257757,11.1428592 19.9395111,11.3538245 Z M14.698505,10.0346317 C14.9526751,10.1657687 15.0825727,10.4247109 14.9889104,10.6134202 C14.8951173,10.8019963 14.6133456,10.8487738 14.3593063,10.7177701 C14.105267,10.5867664 13.9753694,10.3276909 14.0690317,10.1391148 C14.162694,9.9504055 14.4445965,9.90376125 14.698505,10.0346317 Z M7.65361053,9.54081566 C7.90869634,9.88824871 7.92190847,10.3176424 7.68304351,10.4994217 C7.44417854,10.6813343 7.04389004,10.5469988 6.78880423,10.1994325 C6.53371842,9.85186619 6.5206371,9.42260579 6.75937125,9.24082647 C6.99823622,9.05878062 7.39865553,9.19311607 7.65361053,9.54081566 Z M19.676982,9.56861563 C19.8246702,9.78277939 19.70079,10.1307455 19.4004428,10.3455756 C19.0999648,10.560539 18.7368273,10.5610721 18.5891392,10.346775 C18.441451,10.132478 18.5653311,9.78464516 18.8656783,9.56981505 C19.1661563,9.35485168 19.5292939,9.35445187 19.676982,9.56861563 Z M11.9662482,9.21961 C12.1601134,9.29517369 12.2345461,9.5759721 12.1327734,9.84690857 C12.0307391,10.1177118 11.7910893,10.2759024 11.5973549,10.2002055 C11.4037513,10.1246418 11.3291877,9.84371011 11.4310912,9.5729069 C11.5329948,9.3021037 11.7726446,9.14377977 11.9662482,9.21961 Z M8.59228706,7.89207173 C8.84514904,7.89314074 9.04895607,8.1923303 9.04752469,8.56028682 C9.04607817,8.92824334 8.83991652,9.22583368 8.58705453,9.22477038 C8.33419255,9.22370137 8.13038553,8.9245118 8.1318169,8.55655528 C8.13326342,8.18859876 8.33942508,7.89100843 8.59228706,7.89207173 Z M15.1156815,8.53183383 C15.2124833,8.71881065 15.0869026,8.98015174 14.8350871,9.11542007 C14.5832716,9.25095494 14.300715,9.20910838 14.2039132,9.02213156 C14.1071114,8.83528801 14.2326921,8.57394693 14.4843768,8.43854532 C14.7360615,8.30301045 15.0187489,8.34485701 15.1156815,8.53183383 Z M18.5896624,8.24129344 C18.7898067,8.44759431 18.8325826,8.73518945 18.6850253,8.88378471 C18.5374679,9.03251324 18.2556962,8.98586899 18.0554212,8.77970139 C17.8551461,8.57353379 17.812501,8.28580539 17.9600583,8.13707685 C18.1074848,7.98848159 18.3893873,8.03512584 18.5896624,8.24129344 Z M12.0997039,7.71806487 C12.2260694,7.86759301 12.158439,8.13812968 11.9486146,8.32204131 C11.7389209,8.5060862 11.4663062,8.53393948 11.3398098,8.38441134 C11.2134442,8.23474992 11.2810746,7.96434652 11.4907682,7.78030163 C11.7007235,7.59625673 11.9732075,7.56840345 12.0997039,7.71806487 Z M15.4317393,7.14628629 C15.6479736,7.44107796 15.6590927,7.80516968 15.4565939,7.95936225 C15.2539642,8.11355482 14.9145038,7.99974285 14.6981387,7.70495117 C14.4819044,7.41015949 14.4707853,7.04606778 14.6732842,6.8918752 C14.8759139,6.73768263 15.2152434,6.85149461 15.4317393,7.14628629 Z M16.9199623,6.750783 C17.1099031,6.78956437 17.219917,7.04517487 17.1654987,7.32184193 C17.1110804,7.59837571 16.9128984,7.79108311 16.7229575,7.75230175 C16.5330167,7.71352038 16.4230028,7.45790988 16.4774211,7.18137609 C16.5318394,6.90484231 16.7300215,6.71200164 16.9199623,6.750783 Z M10.6958162,6.36426207 C10.9468468,6.39531381 11.1152034,6.71662608 11.0717734,7.08191722 C11.0283435,7.44720835 10.7897401,7.7182781 10.5387095,7.68735962 C10.2876789,7.65644114 10.1193223,7.33499561 10.1627523,6.96970447 C10.2061823,6.60441334 10.4447856,6.33334359 10.6958162,6.36426207 Z",
    id: "Combined-Shape",
    fill: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(54.000000, 29.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-16)",
    xlinkHref: "#path-15"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FF520B",
    fillRule: "evenodd",
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D9D9D9",
    cx: 12.661685,
    cy: 12.661685,
    r: 11.5840948
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0168553,13.87521 C13.1805526,13.9355196 13.3071213,14.0681961 13.3596548,14.2345521 L14.9837979,19.377672 C15.3994322,20.6938473 14.6693995,22.0977564 13.3532243,22.5133906 C13.1097648,22.5902726 12.855962,22.6293945 12.6006518,22.6293945 C11.2874548,22.6293945 10.2228984,21.5648381 10.2228984,20.2516411 C10.2228984,19.9711379 10.2725318,19.6928473 10.3695032,19.429639 L12.2927435,14.2094155 C12.4004131,13.9171693 12.7246091,13.7675404 13.0168553,13.87521 Z M14.2852854,13.3234878 L19.070463,15.8117802 C20.2950373,16.4485588 20.7715398,17.9574835 20.1347612,19.1820578 C20.0169731,19.4085733 19.8651708,19.6157024 19.6846392,19.796234 C18.7560687,20.7248045 17.2505585,20.7248045 16.3219881,19.796234 C16.1236423,19.5978883 15.9619573,19.366011 15.8444101,19.1113255 L13.5130909,14.0601339 C13.3825755,13.7773506 13.5060131,13.4423059 13.7887963,13.3117905 C13.9471931,13.2386843 14.1305072,13.2430032 14.2852854,13.3234878 Z M12.0726128,13.8140771 C12.145719,13.9724739 12.1414001,14.155788 12.0609155,14.3105661 L9.57262309,19.0957438 C8.93584446,20.3203181 7.42691978,20.7968206 6.20234549,20.160042 C5.97582996,20.0422539 5.76870087,19.8904516 5.58816927,19.70992 C4.65959879,18.7813495 4.65959879,17.2758393 5.58816927,16.3472689 C5.786515,16.1489231 6.01839228,15.9872381 6.27307782,15.8696909 L11.3242695,13.5383717 C11.6070527,13.4078563 11.9420975,13.5312938 12.0726128,13.8140771 Z M22.5133906,11.9701458 C22.5902726,12.2136052 22.6293945,12.467408 22.6293945,12.7227183 C22.6293945,14.0359152 21.5648381,15.1004717 20.2516411,15.1004717 C19.9711379,15.1004717 19.6928473,15.0508383 19.429639,14.9538668 L14.2094155,13.0306266 C13.9171693,12.9229569 13.7675404,12.598761 13.87521,12.3065148 C13.9355196,12.1428174 14.0681961,12.0162487 14.2345521,11.9637153 L19.377672,10.3395721 C20.6938473,9.92393783 22.0977564,10.6539705 22.5133906,11.9701458 Z M5.07172898,10.2228984 C5.35223221,10.2228984 5.63052281,10.2725318 5.89373109,10.3695032 L11.1139546,12.2927435 C11.4062008,12.4004131 11.5558297,12.7246091 11.44816,13.0168553 C11.3878505,13.1805526 11.2551739,13.3071213 11.088818,13.3596548 L5.94569803,14.9837979 C4.62952276,15.3994322 3.22561372,14.6693995 2.80997942,13.3532243 C2.7330975,13.1097648 2.69397554,12.855962 2.69397554,12.6006518 C2.69397554,11.2874548 3.75853202,10.2228984 5.07172898,10.2228984 Z M9.03713445,5.61345006 C9.23548019,5.8117958 9.39716525,6.04367307 9.51471242,6.29835862 L11.8460316,11.3495502 C11.976547,11.6323335 11.8531095,11.9673782 11.5703262,12.0978936 C11.4119294,12.1709998 11.2286153,12.1666809 11.0738372,12.0861963 L6.28865952,9.59790388 C5.06408523,8.96112525 4.5875827,7.45220058 5.22436133,6.22762629 C5.34214941,6.00111075 5.49395168,5.79398166 5.67448329,5.61345006 C6.60305377,4.68487958 8.10856397,4.68487958 9.03713445,5.61345006 Z M19.156777,5.24964212 C19.3832926,5.3674302 19.5904216,5.51923248 19.7709532,5.69976408 C20.6995237,6.62833456 20.6995237,8.13384477 19.7709532,9.06241524 C19.5726075,9.26076098 19.3407302,9.42244604 19.0860447,9.53999321 L14.0348531,11.8713124 C13.7520698,12.0018278 13.4170251,11.8783902 13.2865097,11.595607 C13.2134035,11.4372102 13.2177224,11.2538961 13.298207,11.099118 L15.7864994,6.31394031 C16.423278,5.08936602 17.9322027,4.61286349 19.156777,5.24964212 Z M12.7227183,2.69397554 C14.0359152,2.69397554 15.1004717,3.75853202 15.1004717,5.07172898 C15.1004717,5.35223221 15.0508383,5.63052281 14.9538668,5.89373109 L13.0306266,11.1139546 C12.9229569,11.4062008 12.598761,11.5558297 12.3065148,11.44816 C12.1428174,11.3878505 12.0162487,11.2551739 11.9637153,11.088818 L10.3395721,5.94569803 C9.92393783,4.62952276 10.6539705,3.22561372 11.9701458,2.80997942 C12.2136052,2.7330975 12.467408,2.69397554 12.7227183,2.69397554 Z",
    id: "Combined-Shape",
    fill: "#FF520B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7864401,9.96043974 C12.5279532,9.92918962 12.3545958,9.60429617 12.3993158,9.23508682 C12.4440358,8.86587748 12.6897264,8.59190016 12.9482133,8.62315028 C13.2067003,8.6545351 13.3800576,8.97929385 13.3353376,9.34850319 C13.2906176,9.71771254 13.0449271,9.99168985 12.7864401,9.96043974",
    id: "Fill-65",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0924646,15.8871859 C9.83397763,15.8559358 9.6606203,15.5310424 9.70534029,15.161833 C9.75006029,14.7926237 9.99575086,14.5186464 10.2542378,14.5498965 C10.5127248,14.5812813 10.6860821,14.90604 10.6413621,15.2752494 C10.5966421,15.6444587 10.3509515,15.918436 10.0924646,15.8871859",
    id: "Fill-65",
    fill: "#F8F8F8",
    transform: "translate(10.173351, 15.218541) rotate(38.000000) translate(-10.173351, -15.218541) "
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlateIcon);
export default __webpack_public_path__ + "static/media/plate-icon.c8b717967800b6968e61f70ca96dc053.svg";
export { ForwardRef as ReactComponent };